import React, { FunctionComponent } from "react";
import { Input, Label } from "@trussle/external-components";
import { CalculatorTooltip } from "../../calculatorTooltip";

export interface IProps {
  propertyValue: string;
  currentMonthlyRepayment: string;
  mortgageTerm: string;
  outstandingBorrowAmount: string;
  setPropertyValue: (value: string) => void;
  setCurrentMonthlyRepayment: (value: string) => void;
  setMortgageTerm: (value: string) => void;
  setOutstandingBorrowAmount: (value: string) => void;
}

export const allowNumbersOnlyKeyPressHandler = (evt: any) => {
  if (evt.charCode < 48 || evt.charCode > 57) {
    evt.preventDefault();
  }
};

export const RemortgageForm: FunctionComponent<IProps> = (props) => {
  const {
    propertyValue,
    currentMonthlyRepayment,
    mortgageTerm,
    outstandingBorrowAmount,
    setPropertyValue,
    setCurrentMonthlyRepayment,
    setMortgageTerm,
    setOutstandingBorrowAmount,
  } = props;
  return (
    <div className="remortgageForm">
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  The current value of the property, if you were to sell it today.
                </p>
                <p className="calculator-tooltip-p">
                  Get a free valuation from an estate agent if you don’t have a
                  recent valuation.
                </p>
              </>
)}
            />

          )}
          className="calculator-label"
          htmlFor="propertyValue"
        />
        <Input
          variant="currency"
          name="Property value"
          label="Property value"
          inputSize="large"
          id="propertyValue"
          value={propertyValue}
          onChange={(e) => setPropertyValue(e.target.value)}
          required
          className="calculator-input"
          data-testid="propertyValue"
        />
      </div>
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  The remaining debt on your mortgage for this property.
                </p>
                <p className="calculator-tooltip-p">
                  You can find this number on your annual mortgage statement, or
                  phone up the lender and ask.
                </p>
              </>
            )}
            />

          )}
          className="calculator-label"
          htmlFor="outstandingBorrowAmount"
        />
        <Input
          variant="currency"
          name="Outstanding borrow amount"
          label="Outstanding mortgage amount"
          inputSize="large"
          id="outstandingBorrowAmount"
          type="text"
          value={outstandingBorrowAmount}
          onChange={(e) => setOutstandingBorrowAmount(e.target.value)}
          className="calculator-input"
          data-testid="outstandingBorrowAmount"
        />
      </div>
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  How much you pay each month to the mortgage lender for this
                  mortgage.
                </p>
                <p className="calculator-tooltip-p">
                  You can find this amount on a recent bank statement.
                </p>
              </>
            )}
            />
          )}
          className="calculator-label"
          htmlFor="currentMonthlyRepayment"
        />
        <Input
          variant="currency"
          name="Current monthly repayment"
          label="Current monthly repayment"
          inputSize="large"
          id="currentMonthlyRepayment"
          type="text"
          value={currentMonthlyRepayment}
          onChange={(e) => setCurrentMonthlyRepayment(e.target.value)}
          required
          className="calculator-input"
          data-testid="currentMonthlyRepayment"
        />
      </div>
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  The number of years remaining on your current mortgage.
                </p>
                <p className="calculator-tooltip-p">
                  Find this on your annual mortgage statement, or phone up your
                  lender and ask.
                </p>
              </>
            )}
            />

          )}
          className="calculator-label"
          htmlFor="mortgageTerm"
        />
        <Input
          name="Mortgage Term"
          inputSize="large"
          label="Mortgage term (years)"
          id="mortgageTerm"
          type="text"
          inputMode="numeric"
          data-testid="mortgageTerm"
          value={mortgageTerm}
          onChange={(e) => setMortgageTerm(e.target.value)}
          className="calculator-input"
          onKeyPress={allowNumbersOnlyKeyPressHandler}
        />
      </div>
    </div>
  );
};
